import styled from 'styled-components'
import tw from 'tailwind.macro'

export const HeroImage = styled.img`
  ${tw`w-full lg:w-auto h-auto lg:h-500px m-auto mt-8 block`};
`

export const SectionCopy = styled.p`
  ${tw`text-black text-lg md:text-xl lg:text-2xl pt-6 md:pt-12 w-9/10 lg:w-3/5 leading-normal`};
`

export const AltSectionCopy = styled.p`
  ${tw`text-white text-lg md:text-xl lg:text-2xl pt-6 md:pt-12 w-9/10 lg:w-3/5 leading-normal`};
`

export const SectionList = styled.ul`
  ${tw``};
`

export const SectionListItem = styled.li`
  ${tw`text-white text-lg md:text-xl lg:text-2xl pt-6 md:pt-12 w-9/10 lg:w-3/5 leading-normal`};
  list-style-position: inside;
`

export const RoleWrapper = styled.div`
  ${tw`flex flex-row flex-wrap justify-center items-center`};
`

export const RoleHeader = styled.div`
  ${tw`text-white`};
  margin: .4em .8em .4em 0;
`

export const RoleItem = styled.div`
  ${tw`rounded`};
  margin: .4em .8em .4em 0;
  padding: .45em .8em .4em;
  background: #fff;
`